const validateCPF = (val, msk) => {
  var regex =
    msk != undefined && msk ? /^\d{3}\.\d{3}\.\d{3}\-\d{2}$/ : /^[0-9]{11}$/;

  if (val.match(regex) != null) {
    //check all same numbers
    if (val.match(/\b(.+).*(\1.*){10,}\b/g) != null) return false;

    var strCPF = val.replace(/\D/g, "");
    var sum;
    var rest;
    sum = 0;

    for (let i = 1; i <= 9; i++)
      sum = sum + parseInt(strCPF.substring(i - 1, i)) * (11 - i);

    rest = (sum * 10) % 11;

    if (rest == 10 || rest == 11) rest = 0;

    if (rest != parseInt(strCPF.substring(9, 10))) return false;

    sum = 0;
    for (let i = 1; i <= 10; i++)
      sum = sum + parseInt(strCPF.substring(i - 1, i)) * (12 - i);

    rest = (sum * 10) % 11;

    if (rest == 10 || rest == 11) rest = 0;
    if (rest != parseInt(strCPF.substring(10, 11))) return false;

    return true;
  }

  return false;
};

export default validateCPF;



// WEBPACK FOOTER //
// ./src/components/Validators/CPF.js